import { useSelector } from "react-redux"
import styled from "styled-components"
import AracSvg from "../../icons/nakliyeHesaplama/AracSvg"
import LambaSvg from "../../icons/nakliyeHesaplama/LambaSvg"
import BuzulSvg from "../../icons/nakliyeHesaplama/BuzulSvg"
import treeImg from "../../../images/svg/genel/tree.svg"
import formatConverter from "../../../helper/formatConverter"

const Container = styled.div`
    
    padding: 20px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    .data-side{
        width: 200px !important;
        height: 100%;
        background-color: var(--color-green);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        font-size: var(--font-size-sm);
        color: #fff;
        padding: 15px 10px;
        border-radius: 10px;

        .grp{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 5px;

            .text{
                font-weight: var(--font-weight-sm);
                text-align: center;
            }

            .res{
                font-weight: var(--font-weight-lg);
                font-size: var(--font-size-md);
                padding: 10px;
                background-color: rgba(0,0,0,0.3);
                border-radius: 5px;
                text-align: center;
            }
        }
    }

    .desc-side{
        color: ${({theme}) => theme.mainTextColor};
        margin-top: 10px;
        width: calc(100% - 230px);
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-left: 30px;

        .desc-list{
            display: flex;
            flex-direction: column;
            gap: 10px;

            p{
                font-size: 12px;
                font-weight: var(--font-weight-md);
            }
        }

        .desc-result{
            display: flex;
            align-items: center;
            gap: 30px;

            div{
                font-size: 28px;
                font-weight: var(--font-weight-lg);
                font-weight: 800;
                span{
                    font-size: var(--font-size-sm);

                }
            }

            .grp{
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 5px;

                .img-container{
                    height: 30px;
                    display: flex;
                    align-items: flex-end;
                }

                p{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                }
            }
        }
    }
`

const SeraGazResult = () => {

    const {
        resSeraData
    } = useSelector(state => state.nakliyeHesaplama)

  return (
    <Container>

        <div className="data-side">
            <div className="grp">
                <div className="text">Toplam Sera Gazı Emisyonu</div>
                <div className="res">{formatConverter(resSeraData?.emisyonSonuc, 1)}</div>
                <div className="text">Kg C0<sub>2</sub></div>
            </div>

            <div className="grp">
                {/* <AracSvg/> */}
                <div className="text">Bu Emisyon</div>
                <img src={treeImg} alt="tree" />
                <div className="res">{resSeraData?.agacSayisi}</div>
                <div className="text">Adet Ağaca Eşittir.</div>
            </div>
        </div>

        <div className="desc-side">
            <div className="desc-list">
                <p>Karbon dioksit (CO<sub>2</sub>), Metan (CH<sub>4</sub>), Nitröz Oksit (N<sub>2</sub>O) gibi atmosferde sera gazı etkisi göstererek ısı tutma özelliğine sahip gazlara sera gazı denir.</p>
                <p>Güneşten dünyamıza gelen ışınlar atmosferden filtrelenerek geçer. Sera gazları yeryüzü etrafında sera etkisi yaparak dünyamızın ısısının artmasına sebep olur. Bu da dünyanın her geçen gün ortalama sıcaklıkların artmasına, iklimlerin değişmesine, buzulların azalmasına, denizlerin yükselmesine sebep olmaktadır.</p>
                <p>Araçlarımızda fosil yakıtların yanması sonucu ekzozdan bu sera gazları atılmaktadır. Bu da dünyamızı daha ısıtmakta ve iklimlerin değişmesine sebep olmaktadır. Denizler yükselmeye ve dünyamız çölleşmeye doğru gitmektedir.</p>
                <p>Salınan sera gazlarını azaltmanın yollarından biri de; araçların bakımlarının yapılması, yakıt verimliliği ve daha az fosil yakıt kullanılmasıdır.</p>
            </div>
            <div className="desc-result">
                <div style={{paddingTop: "15px"}}>1 ton CO<sub>2</sub>=</div>
                <div className="grp">
                    <div className="img-container">
                        <AracSvg/>
                    </div>
                    <div>4.280 <span>Km</span></div>
                    <p>Araç Kullanımı</p>
                </div>
                <div>=</div>
                <div className="grp">
                    <div className="img-container">
                        <LambaSvg/>
                    </div>
                    <div>10 <span>Yıl</span></div>
                    <p>Ampül Kullanımı</p>
                </div>
                <div>=</div>
                <div className="grp">
                    <div className="img-container">
                        <BuzulSvg/>
                    </div>
                    <div>3 <span>m<sup>3</sup></span></div>
                    <p>Buzul Erimesine Eşittir</p>
                </div>
            </div>
        </div>

    </Container>
  )
}

export default SeraGazResult